import React from 'react'
import { useHistory } from 'react-router-dom'

import './DataBox.scss'

const DataBox = ({ title, text, linkText, linkUrl, colorTheme = 'blue' }) => {
    const history = useHistory()

    return (
        <div className={`data-box theme--${colorTheme}`}>
            <div className={`data-box__description theme--${colorTheme}`}>
                <div className="data-box__description-title">{title}</div>
                <div className="data-box__description-text">{text}</div>
            </div>
            <div className="data-box__button">
                <button className="button" data-variant="primary--inverse" onClick={() => history.push(linkUrl)}>
                    {linkText}
                </button>
            </div>
        </div>
    )
}

export default DataBox
